module.exports = __webpack_public_path__ + "img/Waiting-Room-Outline-1.9fc8a425.svg";